<template>
  <base-button class="btn-primary px-5" text="拒否" />
</template>
  
  <script>
  import BaseButton from '@/views/atoms/BaseButton';
  
  export default {
    name: 'RejectButton',
    components: {
      BaseButton,
    },
  }
  </script>
  